if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');         
      if(!this.form) return;
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);   
      
       if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

      
      config.body = formData;
    

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
            console.log(Object.fromEntries(formData.entries()));
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');          
        });
    }

    handleErrorMessage(errorMessage = false) {
       if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

$(document).ajaxComplete(function() {
  //CartJS.updateCart();
});

(function() {
  if (window.mkGiftWrapCopyFixBound) return;
  window.mkGiftWrapCopyFixBound = true;

  function normalizeGiftWrapCopy() {
    var wrap = document.getElementById('ptw-wrapin');
    if (!wrap) return;

    wrap.querySelectorAll('.ptw-app-label label').forEach(function(label) {
      var price = label.querySelector('.ptw-price');
      if (!price) return;

      var walker = document.createTreeWalker(label, window.NodeFilter ? NodeFilter.SHOW_TEXT : 4);
      var textNode;
      while ((textNode = walker.nextNode())) {
        var updatedText = textNode.nodeValue.replace(/special occasion\.\s*$/i, 'special occasion ');
        if (updatedText !== textNode.nodeValue) {
          textNode.nodeValue = updatedText;
        }
      }

      var amount = price.getAttribute('data-amount') || price.textContent.replace(/[^\d.]/g, '');
      amount = amount.replace(/\.00$/, '');
      if (amount) {
        var updatedPrice = '(AED ' + amount + ').';
        if (price.textContent !== updatedPrice) {
          price.textContent = updatedPrice;
        }
      }
    });
  }

  function startGiftWrapCopyFix() {
    normalizeGiftWrapCopy();
    window.setTimeout(normalizeGiftWrapCopy, 500);
    window.setTimeout(normalizeGiftWrapCopy, 1500);
    window.setTimeout(normalizeGiftWrapCopy, 3000);

    if (!window.mkGiftWrapCopyObserverStarted && document.body && window.MutationObserver) {
      window.mkGiftWrapCopyObserverStarted = true;
      var observer = new MutationObserver(normalizeGiftWrapCopy);
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startGiftWrapCopyFix);
  } else {
    startGiftWrapCopyFix();
  }
  window.addEventListener('load', normalizeGiftWrapCopy);
})();
